import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=46320bc6&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=46320bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46320bc6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutListNavigationDrawer: require('/home/luiz/Sistemas/loja/components/Layout/ListNavigationDrawer.vue').default,CartNavigationDrawer: require('/home/luiz/Sistemas/loja/components/CartNavigationDrawer.vue').default,CartEmpty: require('/home/luiz/Sistemas/loja/components/CartEmpty.vue').default,DarkMode: require('/home/luiz/Sistemas/loja/components/DarkMode.vue').default,ContaLogin: require('/home/luiz/Sistemas/loja/components/ContaLogin.vue').default,LayoutListAppBar: require('/home/luiz/Sistemas/loja/components/Layout/ListAppBar.vue').default})
